<template>
    <q-card :inline="inline" class="card" :style="style">
        <template v-if="inEdit">
            <q-card-main>
                <q-field
                    label="Tytuł"
                    class="q-mb-md">
                    <q-input
                        v-model="part.title"
                    ></q-input>
                </q-field>


                <drop-area
                    @dropped="e => handleDropFromRepo(e)"
                    style="position: relative;">


                    <template v-if="part.url">
                        <generic-viewer :articlePart="part" :src="part.url"/>

                        <q-btn
                            icon="delete"
                            dense
                            flat
                            class="absolute-top-right"
                            style="right: 0px; top: 10px;"
                            @click="part.url = undefined"/>
                    </template>
                    <template v-else>
                        Przeciągnij tu materiał z repozytorium
                    </template>
                </drop-area>

                <q-editor @paste.native="paste" v-model="part.text"/>

                <q-color placeholder="Kolor tła" format-model="hex" v-model="part.backgroundColor"/>
            </q-card-main>

            <q-card-actions align="end" class="actions"
                            @dragover.native.prevent="() => {}"
                            @dragleave.native="() => {}"
                            @dragenter.native="() => {}"
                            @drop.native="dropBackground">
                <q-btn flat round icon="edit" @click.native="goToEdit(localModel.id)"/>
                <q-btn flat round icon="delete" @click.native="confirmAndDelete"/>
            </q-card-actions>

        </template>

        <template v-else>
            <q-card-main>
                <generic-viewer :articlePart="part" :src="part.url"/>
                <div class="text-right">
                    <!--<a href="#" @click.prevent="removeArticle(part)">Usuń</a>-->
                </div>
            </q-card-main>
        </template>
    </q-card>
</template>

<script>
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'
    import QCardMedia from 'quasar-framework/src/components/card/QCardMedia'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import QCardActions from 'quasar-framework/src/components/card/QCardActions'
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QEditor from 'quasar-framework/src/components/editor/QEditor'
    import QField from 'quasar-framework/src/components/field/QField'
    const GenericViewer = () => import('./viewers/GenericViewer')
    import QCard from 'quasar-framework/src/components/card/QCard'
    import QChipsInput from 'quasar-framework/src/components/chips-input/QChipsInput'
    import draggable from 'vuedraggable'
    import QToggle from 'quasar-framework/src/components/toggle/QToggle'
    import QInput from 'quasar-framework/src/components/input/QInput'
    import QRadio from 'quasar-framework/src/components/radio/QRadio'
    import QColor from 'quasar-framework/src/components/color/QColor'
    import DropArea from '../DropArea'
    import { pasteCapture } from '../../lib/editor-paste'

    export default {
        name: 'ArticlePartComponent',
        components: {
            DropArea,
            QColor,
            QRadio,
            QInput,
            QToggle,
            QChipsInput,
            QCard,
            GenericViewer,
            QField,
            QEditor,
            QBtn,
            QIcon,
            QCardActions,
            QCardMain,
            QCardMedia,
            QCardTitle,
            draggable,
        },
        props: ['model', 'editable', 'inEdit', 'inline'],
        methods: {
            paste (evt) {
                pasteCapture(evt, this.$refs.editor_ref);
            },
            handleDropFromRepo (e) {
                if (this.inEdit) {
                    try {
                        const model = JSON.parse(e.dataTransfer.getData('text'))
                        switch (model.type) {
                            case 'picture':
                                this.$set(this.part, 'url', model.urlPath)
                                this.$set(this.part, 'category', 'picture')
                                break;
                            case 'video':
                                this.$set(this.part, 'url', model.urlPath)
                                this.$set(this.part, 'category', 'video')
                                break;
                            case 'audio':
                                this.$set(this.part, 'url', model.urlPath)
                                this.$set(this.part, 'category', 'audio')
                                break;
                        }
                    } catch (ee) {
                        // ...
                    }
                }
            },
            dropBackground (e) {
                if (this.inEdit) {
                    try {
                        this.$set(this.model, 'backgroundUrl', JSON.parse(e.dataTransfer.getData('text')).urlPath)
                    } catch (ee) {
                        // ...
                    }
                }
            },
            addTextToArticle () {
                this.text = ''
            },
            confirmAndDelete () {
                this.$q.dialog({
                    title: `Potwierdź usunięcie sekcji`,
                    message: `Czy na pewno usunąć sekcję?`,
                    ok: 'Usuń',
                    cancel: 'Anuluj',
                    position: 'top',
                }).then(() => {
                    this.$emit('delete')
                })
            },

        },
        data () {
            return {
                draggingOver: false,
                defaultModel: {
                    text: ''
                }
            }
        },
        watch: {
            bgr (value) {
                if (value) {
                    this.part.backgroundColor = undefined
                }
            },
            bgrColor (value) {
                if (value) {
                    this.part.backgroundUrl = undefined
                }
            }
        },
        computed: {
            bgr () {
                return this.part.backgroundUrl
            },
            bgrColor () {
                return this.part.backgroundColor
            },
            part () {
                return this.model || this.defaultModel
            },
            style () {
                let value = ''

                if (this.part.backgroundUrl) {
                    value += `background: url(${this.$store.state.MEDIA_PREFIX_FOR_IMG + this.part.backgroundUrl}); background-size: cover; `
                }

                if (this.part.backgroundColor) {
                    value += `background-color: ${this.part.backgroundColor}; `
                }

                return value
            },
        },
    }
</script>

<style scoped lang="scss">
    .card {
        border-radius: 20px;

        .actions {
            background: gainsboro;
        }
    }

    .inline {
        display: inline;
    }

    .card:not(.inEdit) {
        width: 350px;
        /*height: 500px;*/
        overflow: hidden;
        position: relative;

        .media {

        }

        .main {

        }

        /*.actions {*/
            /*display: none;*/
        /*}*/

        /*&:hover .actions {*/
            /*display: flex;*/
        /*}*/
    }

    .card.inEdit {
        width: 350px;
        position: relative;

        .media {

        }

        .main {

        }

        &.draggingOver {
            border: 1px solid red;
        }
    }

    .new-content-area {
        border: 1px dashed gray;
        min-height: 30px;
        line-height: 30px;
        color: gray;
    }

</style>
